export enum EntityChangeType {
  INSERT = "INSERT",
  DELETE = "DELETE",
  UPDATE = "UPDATE"
}

export class EntityChangeEvent {
  public id: number;
  public entity: string;
  public action: EntityChangeType;
  public payload: any;
  // public href: string;
}
